module.exports = __webpack_public_path__ + "img/Minilogo_RUTUBE_white_mono.a312060a.svg";